// extracted by mini-css-extract-plugin
export default {"loader":"spinner_loader__rOpaf","load1":"spinner_load1__MCp3y"};